
/**
 * Events that get raised for actions on documents.
 */
export enum DocumentEvents {
	/**
	 * Occurs when a new revision has been created for a document.
	 */
	Edit = 'edit'
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/events.ts